<template>
    <div class="party-settings" :class="{'party-settings-saving': saving}">
        <form @submit.prevent="submitParty">
            
            <div v-if="debug">
                <pre>fields:</pre>
                <pre>{{fields}}</pre>
                <pre>savedFields:</pre>
                <pre>{{savedFields}}</pre>
            </div>

            <div class="flex-column">

                <div class="form-row flex-row">
                    <div class="form-row-element">
                        <div class="input-wrapper">
                            <label class="base-label">{{$t('form.party.date')}}</label>
                            <datepicker class="base-input" :locale="currentLocale" :inputFormat="dateFormat" v-model="fields.date" ref="date"/>
                        </div>
                    </div>
                    <div class="form-row-element-small">
                        <div class="input-wrapper">
                            <label class="base-label"> </label>
                            <VueTimepicker class="base-input"
                                           v-model="fields.time"
                                           minute-interval="10" format="HH:mm"
                                           clearable="false"
                                           hideClearButton
                                           dropDirection="down"
                                           close-on-complete
                            />
                        </div>
                    </div>
                </div>

                <div class="form-row flex-row" v-if="selectedHost === -1">
                    <div class="form-row-element">
                        <div class="widget-body">
                            <div class="filter">
                                <FormFilter ref="filter" px-0
                                    :label="$t('form.party.host')"
                                    :placeholder="$t('widget.customers.search')"
                                    @update-search-string="searchStringUpdated"
                                    @update="customersUpdated"
                                    @focus="()=>{filterInFocus = true}"

                                />
                            </div>
                            <CustomerList v-if="showCustomerList"
                                :customers="customers"
                                :filtered="filtered"
                                @customer-element-clicked="setHost"
                                @customer-clicked="setHost"
                                :show-sales-volume="showSalesVolume"
                            />
                         </div>
                         <div class="add-cust-button" v-if="filtered.length > 0 && customers.length == 0">
                             <AddButtonGreen :text="$t('form.party.addNewHost')"  @click="addHostWithFilterClicked"  class="widget-add-button" style="color: #2c3536;width: 100%;"/>
                         </div>
                    </div>
                </div>

                <div class="form-row flex-row" v-else>
                    <div class="form-row-element">
                        <div class="input-wrapper host-input">
                            <label class="base-label">{{$t('form.party.host')}}</label>
                            <div style="text-transform: capitalize;min-height: 44px" class="selected-host__details base-input" @click="clearSelectedHost">{{ hostNameDisplay }}</div>
                            <Spinner class="host-spinner" v-if="hostLoading" :size="24"/>
                        </div>
                    </div>
                </div>

                <div class="form-row flex-row">
                    <div class="form-row-element">
                        <div class="input-wrapper">
                            <label class="base-label">{{$t('form.party.onlineParty')}}</label>
                            <div class="input-subtext">{{$t('form.party.onlinePartyText')}}</div>
                        </div>
                    </div>
                    <div class="form-row-element-auto">
                        <div class="input-wrapper">
                            <label class="base-label"></label>
                            <Toggle v-model="fields.isOnline" id="onlineParty" :colors="colors" :width="64" :height="32"/>
                        </div>
                    </div>
                </div>

                <!--end date-->
                <div class="form-row" style="flex-direction: column" v-if="fields.isOnline">
                    <label class="base-label"  style="padding: 6px">{{$t('form.party.endDate')}}</label>
                    <div class="input-subtext"  style="padding: 6px">{{$t('form.party.endDateText')}}</div>
                    <div class="flex-row end-date-group">
                        <div class="form-row-element">
                            <div class="input-wrapper">
                                <datepicker class="base-input" :locale="currentLocale" :inputFormat="dateFormat" v-model="fields.endDate"/>
                            </div>
                        </div>
                    <div class="form-row-element-small">
                        <div class="input-wrapper">
                            <VueTimepicker class="base-input"
                                v-model="fields.endTime"
                                           minute-interval="10" format="HH:mm"
                                           hideClearButton
                                           close-on-complete
                            />
                        </div>
                    </div>
                    </div>
                </div>

                <!--shipping fee-->
                <div class="form-row" style="flex-direction: column" v-if="fields.isOnline">
                    <label class="base-label"  style="padding: 6px">{{$t('form.party.shippingFee')}}</label>
                    <div class="input-subtext"  style="padding: 6px">{{$t('form.party.shippingFeeText')}}</div>
                    <div class="form-row-element-tiny">
                        <BaseInput v-model="fields.shippingFee"/>
                    </div>
                </div>

                <!-- link to facebook -->
                <div class="form-row "  style="flex-direction: column" v-if="fields.isOnline">
                    <label class="base-label"  style="padding: 6px">{{$t('form.party.linkToFacebook')}}</label>
                    <div class="input-subtext"  style="padding: 6px">{{$t('form.party.linkToFacebookText')}}</div>
                    <div class="form-row-element-auto">
                        <BaseInput v-model="fields.linkToFacebook"/>
                    </div>
                </div>

                <!-- payment info -->
                <div class="form-row "  style="flex-direction: column" v-if="fields.isOnline">
                    <div class="form-row-element-auto">
                        <BaseTextArea v-model="fields.paymentInformation" :label="$t('form.party.paymentInformation')"/>
                    </div>
                </div>

                <!-- auto reserve -->
                <div class="form-row flex-row" v-if="fields.isOnline">
                    <div class="form-row-element">
                        <div class="input-wrapper">
                            <label class="base-label">{{$t('form.party.autoReserve')}}</label>
                            <div class="input-subtext">{{$t('form.party.autoReserveText')}}</div>
                        </div>
                    </div>
                    <div class="form-row-element-auto">
                        <div class="input-wrapper">
                            <label class="base-label"></label>
                            <Toggle v-model="fields.autoReserve" id="autoReserve" :colors="colors" :width="64" :height="32"  />
                        </div>
                    </div>
                </div>

            </div>

            <div class="save-changes">
                <button v-if="showSaveChanges" class="button-primary button-primary__thin button-primary__full-width button-primary__inverse save-changes-button" type="submit" >{{$t('form.party.saveChanges')}}</button>
                <div v-if="party && saving" class="saving-spinner">
                    <Spinner :size="48"/>
                </div>
            </div>

         </form>

        <pre v-if="debug">{{party}}</pre>
    </div>
</template>
<style src="@vueform/toggle/themes/default.css"></style>

<script>
 import * as types from '@/store/mutations'
 import datepicker from 'vue3-datepicker';
 import { nextTick } from 'vue'
 import { nb,sv,fi } from 'date-fns/locale'; // TODO: fix locale here
 import CustomerList from "../lists/CustomerList";
 import FormFilter from '@/components/forms/filter/FormFilter.vue'
 import VueTimepicker from "vue3-timepicker/src/VueTimepicker";
 import AddButtonGreen from "../core/AddButtonGreen";
 import Toggle from '@vueform/toggle';
 import BaseInput from "./inputs/BaseInput";
 import BaseTextArea from "./inputs/BaseTextArea";
 import Spinner from "@/components/core/Spinner.vue";

 export default {
     name: "PartySettings",
     props: {
         party: Object,
         preselectedHost: { type: Number, required: false, default: null },
         preselectedDate: { type: Date, required: false, default: Date() },
         preselectedHostOnly:{ type: Number, required: false, default: null },
     },
     data() { return {
         debug: false,
         showErrors: false,
         hostLoading: true,
         saving: false,
         filtered: '',
         selectedDate:new Date(),
         rawCustomers: [],
         orderby: null,
         customersLoaded: false,
         maxFilterResults: 8,
         filterInFocus: false,
         selectedHost: -1,
         host: null,
         selectedParty:null,
         fields: {
             date: new Date(),
             time: { HH: '17', mm: '00', ss: '00', a: 'am' },
             isOnline: false,
             shippingFee: 49,
             endDate: new Date(),
             endTime: { HH: '18', mm: '00', ss: '00', a: 'am' },
             linkToFacebook: "",
             paymentInformation: "",
             autoReserve: false
         },
         savedFields: {},
         colors: {
             background: {
                 on: '#435152',
                 off: '#FFFFFF',
                 disabled: '#FFFFFF'
             },
             handle: {
                 on:'#F7F9F9 ',
                 off:'#7E9495',
                 disabled: '#FFFFFF'
             }
         },
         dateFormat: "dd.MM.yyyy",
         oldEndDate: null,
     }},
     components: {
         CustomerList,
         AddButtonGreen,
         FormFilter,
         VueTimepicker,
         datepicker,
         Toggle,
         BaseInput,
         BaseTextArea,
         Spinner
     },
     emits: ['save', 'create-host'],
     watch: {
         
         selectedHost: function(id){
             if(!id || id === -1){
                 return
             }
             this.hostLoading = true
             this.$store.dispatch('getCustomer', this.selectedHost)
                 .then(res => {
                     this.host = res
                 })
                 .catch(e => { console.log(e) })
                 .finally(()=>{ this.hostLoading = false })
         },
         preselectedHost: function (id) {
             if(id && id !== -1){
                 this.selectedHost = id
             }
         },
         preselectedDate: function (date) {

             this.fields.date = date

         },
       selectedDate: function (date) {

         this.selectedDate = date

       },
         party: { immediate: true, handler: function (party) {
             if(party){
                 this.populateFields(party)
                 this.selectedParty = party

                 this.loaded = true
             }
         }},
      /*   'fields.date': function(){
             this.$refs.date.$el.getElementsByClassName("base-input")[0].blur()
         },*/
         errors: function(errors){
             if(!errors.length){
                 this.showErrors = false
             }
         },
         'fields.isOnline'(value) {
             if (value === true) {
                 if(!this.fields.endDate.getDate()){
                     this.oldEndDate =  this.fields.endDate
                     this.fields.endDate = this.selectedDate
                 }else{
                     this.oldEndDate =  this.fields.endDate
                 }
             } else {
                 this.fields.endDate = this.oldEndDate

                 this.fields.shippingFee = ''
                 this.fields.linkToFacebook = ''
                 this.fields.paymentInformation = ''
                 this.fields.autoReserve =  false
             }
         }
     },
     computed: {
         currentLocale(){
             let llc = this.$store.getters.dealerLocale()
             console.log("store says: " + llc);
             if (llc == "nb") {
                 return nb
             }
             if (llc == "sv") {
                 return sv
             }
             if (llc == "fi") {
                 return fi
             }
             return nb
         },
         hostNameDisplay(){
             if(this.hostLoading){
                 return ''
             }
             return `${this.host?.firstName ?? ""} ${this.host?.lastName ?? ""}`.trim()
         },
         showSaveChanges(){
             if(this.saving){
                 return false
             }
             if(!this.party){
                 return false
             }
             console.log(this.savedFields)
           console.log(this.fields)
             if(JSON.stringify(this.savedFields) !== JSON.stringify(this.fields)){
                 return true
             }
             return false
         },
         errors(){
             let errors = []
             if(!this.selectedDate|| this.selectedDate.toString() === 'Invalid Date'){
                 errors.push("no-date")
             }
/*
             console.log("selected: "+this.selectedHost )
           console.log("selected: "+ this.preselectedHost )
             if(!this.selectedParty && (this.selectedHost === -1 && this.props.preselectedHost == null )){
                 errors.push("no-host")
             }
  */
             return errors
         },
         anyTagsAreActive(){
             let { builtin, custom } = this.$store.state.customers.filters.activeTags
             if(builtin.length || custom.length){
                 return true
             }
             return false
         },
         customers(){
             let customers = this.rawCustomers
             let items = []

             if(Array.isArray(customers)){
                 items = customers
             }

             if(!Array.isArray(customers)){
                 for(let group of customers){
                     items.push(...group[1])
                     if(items.length > this.maxFilterResults){
                         break
                     }
                 }
             }

             return items.slice(0,this.maxFilterResults)
         },
         showSalesVolume(){
             if(this.orderby === "sales-asc"){
                 return true
             }
             if(this.orderby === "sales-desc"){
                 return true
             }
             return false
         },
         showCustomerList(){
             let hostHasBeenPicked = this.selectedHost !== -1
             if(!this.customersLoaded) { return false }
             if(this.filterInFocus) { return true }
             if(this.showErrors && this.errors[0] === 'no-host'){
                 // only if no-host is the first encountered error
                 return true
             }
             if(!hostHasBeenPicked){
                 if(this.orderby) { return true }
                 if(this.anyTagsAreActive) { return true }
                 if(this.filtered) { return true }
             }
             return false
         }
     },
     mounted(){
         if(this.party){
             this.populateFields(this.party)
         } else {
             this.populateFields(this.fields)
         }

         if(this.preselectedHost !== -1){
             this.selectedHost = this.preselectedHost
         }else if(this.preselectedHostOnly !== -1){
             this.selectedHost = this.preselectedHostOnly
             this.selectedDate = new Date()
             this.fields.date = new Date();
         }else{
             this.selectedHost = -1
         }
         this.oldEndDate = this.fields.endDate
         if(this.fields.isOnline === true && !this.fields.endDate.getDate()){
             this.fields.endDate = this.selectedDate
         }

         this.$store.dispatch('loadAllCustomers').then(()=>{
             this.customersLoaded = true
         })
     },
     methods: {
         validate(){
             // TODO: get rid of side effects
             let valid = true
             if(!this.errors.length){
                 valid = true
             }

             if(this.errors.includes("no-date")){
                 valid = false
                 let message = this.$t("form.party.errors.nodate")
                 // TODO: display error message toast/snackbar
                 console.log("Validation failed:", message)

                 let field = this.$refs.date.$el.getElementsByClassName("base-input")[0]
                 field.focus()
             }

             if(valid && this.errors.includes("no-host")){
                 valid = false
                 let message = this.$t("form.party.errors.nohost")
                 // TODO: display error message toast/snackbar
                 console.log("Validation failed:", message)

                 // will not focus the field, but shows first 8 customers
             }

             if(!valid){
                 this.showErrors = true
                 this.saving = false
             }

             return valid
         },
         populateFields(party){
             let startDate = new Date(party.date.date)
             this.fields.date = startDate
             this.fields.time = this.timeFromDate(startDate)


             let endDate = new Date(party.endDate?.date)
             this.fields.endDate = endDate
             this.fields.endTime = this.timeFromDate(endDate)

             this.host = party.host
             if (this.preselectedHost >- 1){
               this.selectedHost = this.preselectedHost
             }
             else {
               this.selectedHost = party.hostPersonId || -1
             }
             if(party.hostPersonId){
                 console.log(party.hostPersonId)
                 this.selectedDate = new Date(party.date.date)
                 this.selectedHost = party.hostPersonId
                 console.log("host person "+party.hostPersonId)

             }else{
                 this.selectedDate = this.preselectedDate
                 this.selectedHost = -1
                 this.fields.date = this.preselectedDate

             }
             this.fields.isOnline = party.isOnline ? true : false
             this.fields.shippingFee = party.fee

             this.fields.linkToFacebook = party['link-to-party']
             this.fields.paymentInformation = party.paymentDetails
             this.fields.autoReserve = party.autoReserve ? true : false

             this.savedFields = JSON.parse(JSON.stringify(this.fields))
         },
         timeFromDate(date){
             let hours = date.getHours()
             let minutes = date.getMinutes()
             let time = { HH: '12', mm: '00' }

             if(!isNaN(hours)){
                 time.HH = hours < 10 ? `0${hours}` : hours.toString()
             }
             if(!isNaN(minutes)){
                 time.mm = minutes < 10 ? `0${minutes}` : minutes.toString()
             }

             return time
         },
         collectDate(dateString, time){
             let date = new Date(dateString)
             date.setHours(time.HH)
             date.setMinutes(time.mm)
             date.setSeconds(0)
             date.setMilliseconds(0)
             let userTimezoneOffset = date.getTimezoneOffset() * 60000
             date = new Date(date.getTime() - userTimezoneOffset)
             date = date.toISOString().replace('T', ' ').split('Z')[0]
             return date
         },
         submitParty(){

             let fields = JSON.parse(JSON.stringify(this.fields))

             let payload = {
                 dateOfParty: this.collectDate(this.fields.date, fields.time),
                 hostPersonId: this.selectedParty?.hostPersonId ?? this.selectedHost,
                 type: '0'
             }

             // hostPersonId
             // dateOfParty
             // type
             // partytodate
             // freightcost
             // linkToParty
             // paymentDetails
             // autoreserve

             if(fields.isOnline){
                 payload.type = '20'
             }
             console.log(payload.selectedHost)
             payload.partytodate = fields.endDate ? this.collectDate(fields.endDate, fields.endTime) : ''

             payload.freightcost = fields.shippingFee?.toString() || ''
             payload.linkToParty = fields.linkToFacebook?.toString() || ''
             payload.paymentDetails = fields.paymentInformation?.toString() || ''
             payload.autoreserve = fields.autoReserve? 1 : 0

             this.saveChanges(payload)
         },
         saveChanges(payload){
             console.log("party payload:", payload);
             this.saving = true
             this.$emit('save', payload);
         },
         removeFocusFromFilter(){
             // TODO: see if event target was a filter list element, save it right away
             setTimeout(()=>{ this.filterInFocus = false }, 100)
         },
         addCustWithFilterClicked(){
             let prefilledName = this.filtered
             this.$store.commit(types.SET_CREATECUSTOMER_PREFILL, prefilledName)
             this.$emit('create-host')
         },
         addHostWithFilterClicked(){
           let prefilledName = this.filtered
           let prefilledDate = this.selectedDate
           let redirect = true
           this.$store.commit(types.SET_CREATECUSTOMER_PREFILL, prefilledName)
           this.$store.commit(types.SET_CREATEHOST_DATEANDDATA, {prefilledDate:prefilledDate, redirect:redirect})
           this.$emit('create-host')
         },
         setHost(custId){
             this.selectedHost = custId
         },
         clearSelectedHost(){
             if(this.party){
                 // TODO: re-enable changing host of an existing party once api supports it
                 console.warn("Changing host of existing party has been disabled until api supports it");
                 return
             }
             this.selectedHost = -1
         },
         customersUpdated(customers){
             nextTick(()=>{
                 if(this.$refs['filter']){
                     this.orderby = this.$refs['filter'].orderby
                 }
                 this.rawCustomers = customers
             })
         },
         searchStringUpdated(str){
             this.filtered = str
         }
     }
 }
</script>

<style scoped>

</style>
